import React from 'react';
import { FormFieldContainer } from '../../components';
import { checkCondition } from '../../helpers';

interface ConditionalFieldsProps {
  field?: Record<string, any>;
  formik?: Record<string, any>;
  useGridStyles?: boolean;
}

export const ConditionalFields = ({
  field = {},
  formik,
  useGridStyles = false,
}: ConditionalFieldsProps = {}) => {
  const { conditionConfig = {} } = field;
  const isConditionMet = checkCondition(formik?.values, conditionConfig);

  if (isConditionMet) {
    // Handle custom fields for conditional fields
    if (field?.type === 'custom' && field.Field) {
      return <field.Field formik={formik} {...field?.props} />;
    }
    return (
      <FormFieldContainer
        item={field}
        formik={formik}
        useGridStyles={useGridStyles}
      />
    );
  } else return null;
};
